import React, { Fragment, useCallback, useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { Box, Card, CardContent, Divider, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";

const PopoverComponent = ({ info }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Fragment>
      {/* <Button
        startIcon={<IconInfoCircle style={{ width: 14, height: 14, ml: 2 }} />}
        variant="contained"
        size="small"
        style={{ minWidth: 20 }}
        onClick={handleClick}
      >
        <Typography sx={{ color: "white", fontSize: 12 }}>Dettagli</Typography>
      </Button> */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Card>
          <CardContent
            sx={{
              "&.MuiCardContent-root": { p: 0 },
              width: "100%",
            }}
          >
            {info &&
              info.map((item, index) => (
                <Box sx={{ width: "100%" }} key={index}>
                  <Box
                    sx={{
                      width: "100%",
                    }}
                  //p={1}
                  >
                    {item?.title && (
                      <Box
                        sx={{
                          width: "100%",
                          p: 1,
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: grey[100],
                        }}
                      >
                        <Typography variant="h5" color='black'>{item.title}</Typography>
                        <Divider
                          sx={{ marginLeft: -3, marginRight: -1, mt: 1, mb: 1 }}
                        />
                      </Box>
                    )}

                    {item?.content.map((item2, index2) => (
                      <Box sx={{ m: 1, ml: 2 }} key={index2}>
                        <Grid
                          container
                          mb={1}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Grid item xs={10}>
                            <Typography variant="body1" >
                              {item2?.label}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{ display: "flex", justifyContent: "end" }}
                          >
                            <Typography align="right" variant="h4">
                              {item2?.value}
                            </Typography>
                          </Grid>
                        </Grid>
                        {/* <Box mb={1} sx={{ width: "100%", }}>
                                                    <Typography variant="body1" key={index2}>
                                                        {item2?.label}
                                                    </Typography>

                                                    {
                                                        <Typography variant="h4">
                                                            {item2.value}
                                                        </Typography>}

                                                </Box> */}
                        {item.content.length - 1 !== index2 && (
                          <Divider
                            sx={{
                              marginLeft: -3,
                              marginRight: -1,
                              mt: 1,
                              mb: 1,
                            }}
                          />
                        )}
                      </Box>
                    ))}

                    {/* <Typography variant="body1">{item.label}</Typography>
                                        <Typography variant="h4" pl={2}>
                                            {item.value}
                                        </Typography> */}
                  </Box>
                  <Divider />
                </Box>
              ))}
          </CardContent>
        </Card>
      </Popover>
    </Fragment>
  );
};

export default PopoverComponent;
